import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ClientsService } from 'src/app/services/clients.service';
import * as moment from 'moment';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss']
})
export class ClientsComponent implements OnInit {
  items = [];
  pageOfItems: Array<any>;
  public displayForm = false
  public clientForm: FormGroup;
  public submitted = false;
  public isEditForm = false;

  public clients = [];

  constructor(private clientsService : ClientsService) { }

  ngOnInit() {
    this.clientForm = new FormGroup({
      'id': new FormControl(''),
      'first_name': new FormControl('', [Validators.required]),
      'surname': new FormControl('', [Validators.required]),
      'email': new FormControl(''),
      'phone': new FormControl(''),
      'birthday': new FormControl(''),
      'fidelity': new FormControl(''),
      'formula': new FormControl(''),
    });
    this.clientsService.getClients().subscribe((clientSnapshot) => {
      this.clients = [];
      clientSnapshot.forEach((clientData: any) => {
        this.clients.push({
          id: clientData.payload.doc.id,
          data: clientData.payload.doc.data()
        });
      })
    });
    this.items = Array(150).fill(0).map((x, i) => ({ id: (i + 1), name: `Item ${i + 1}`}));
  }

  selectNewClient() {
    this.displayForm = true;
  }

  onSubmit(){
    this.submitted = true;
    if (this.clientForm.valid){
      let formData = this.clientForm.value;
      if (formData.birthday) {
        let selectedDate = moment(formData.birthday);
        formData.birthday = {day: selectedDate.format('DD'), month: selectedDate.format('MMM'), year: selectedDate.format('YYYY')}
      }
      else {
        formData.birthday = {day: null, month: null};
      }
      if (this.isEditForm) {
        this.clientsService.updateClient(formData)
        .then(() => {
          this.onReset()
        })
      }
      else {
        this.clientsService.createClient(formData).then(() => this.onReset())
      }   
    }
    
  }

  onReset(){
    this.submitted = false;
    this.clientForm.reset();
    this.displayForm = false;
    this.isEditForm = false;
  }

  get f(){
    return this.clientForm.controls;
  }

  get formSubmitValue(){
    if (this.isEditForm) {
      return "Actualizar Cliente"
    }
    else {
      return "Añadir Cliente"
    }
  }

  onChangePage(pageOfItems: Array<any>) {
    this.pageOfItems = pageOfItems;
  }

  editClient(client){
    const formElement = document.querySelector("#client-form");
    if (formElement) formElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
    this.clientForm.patchValue({id: client.id, ...client.data});
    if (client.data.birthday){
      let birthday = client.data.birthday
      if (birthday.year){
        this.clientForm.patchValue({
          birthday: moment.utc(`${birthday.day} ${birthday.month} ${birthday.year}`).format('YYYY-MM-DD')
        })
      }
      else {
        this.clientForm.patchValue({
          birthday: moment.utc(`${birthday.day} ${birthday.month} ${moment().format('YYYY')}`).format('YYYY-MM-DD')
        })
      }
    }
    this.displayForm = true;
    this.isEditForm = true;
  }

  deleteClient(){
      this.clientsService.deleteClient(this.f.id.value);
      this.onReset()
    }
}
